import { blurOnPointerClick, button, localize, setText } from "./dom";
import type { Store } from "./store";

/**
 * "New version available" with Reload and ✕. Nothing reloads on its own: the
 * reader decides, and a dismissed message comes back at the next start.
 */
export function mountUpdate(
  container: HTMLElement,
  store: Store,
): { show(apply: () => Promise<void>): void } {
  const pill = document.createElement("div");
  pill.className = "update-pill glass";
  pill.setAttribute("role", "status");
  pill.hidden = true;
  const text = document.createElement("span");
  text.className = "update-pill-text";
  let apply: (() => Promise<void>) | null = null;
  const reload = button(
    "",
    () => {
      // the page reloads once the new version has taken over
      reload.disabled = true;
      void apply?.();
    },
    "pill-button",
  );
  const dismiss = button("✕", () => (pill.hidden = true), "update-dismiss");
  blurOnPointerClick(dismiss);
  pill.append(text, reload, dismiss);
  container.append(pill);
  localize(store, (m) => {
    setText(text, m.update.available);
    setText(reload, m.update.reload);
    dismiss.setAttribute("aria-label", m.update.dismiss);
  });
  return {
    show(next) {
      apply = next;
      reload.disabled = false;
      pill.hidden = false;
    },
  };
}
